import { render } from "./FeatherPlusCircleSvg.vue?vue&type=template&id=23a20726"
const script = {}
script.render = render

export default script